import React from 'react';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

const style = {
    paper: {
        marginTop:"50px",
        padding:"25px 30px 20px 25px",
    }
}

var MeldungWurdeVersandt = (props) => {
  return (
    <Paper style={style.paper}>
      <h2 style={{textAlign:"center", marginBottom:"35px"}}>
        {props.children}
      </h2>
      <div style={{textAlign:"center"}}>
        <Button
            color="primary"
            variant="contained"
            onClick={()=>{window.location.href = "index.php"}}
          >
            Zurück zu den Formularen
          </Button>
        </div>

    </Paper>
  );
}

export default MeldungWurdeVersandt;
